import { PlainButton } from "@jugl-web/ui-kit";
import { cx, useSearchInput } from "@jugl-web/utils";
import { useTicketsViewContext } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/TicketsViewProvider";
import { FC, KeyboardEvent, useRef, useState } from "react";
import { ReactComponent as SearchIcon } from "./assets/search.svg";
import { ReactComponent as CancelIcon } from "./assets/cancel.svg";

export const TicketsViewSearchBar: FC = () => {
  const { searchQuery, setSearchQuery } = useTicketsViewContext();

  const [isFocused, setIsFocused] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const { hasInputValue, inputProps, reset } = useSearchInput({
    defaultValue: searchQuery,
    onSearch: setSearchQuery,
    onReset: () => setSearchQuery(""),
  });

  const handleQuitSearch = () => {
    reset();
    setIsFocused(false);
    inputRef.current?.blur();
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Escape") {
      event.preventDefault();
      handleQuitSearch();
    }
  };

  const isExpanded = isFocused || hasInputValue;

  return (
    <div
      className={cx(
        "relative h-8 shrink-0 overflow-hidden rounded-lg border border-solid border-grey-300 bg-white outline outline-transparent transition-[width,outline] duration-200 ease-in-out outline-solid",
        isExpanded ? "w-[240px] outline-grey-300" : "w-8 hover:outline-grey-300"
      )}
    >
      <div className="pointer-events-none absolute top-2 left-2 h-4 w-4">
        <SearchIcon className="absolute top-[-2.5px] left-[-3px]" />
      </div>

      <input
        ref={inputRef}
        type="text"
        {...inputProps}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onKeyDown={handleKeyDown}
        placeholder="Search..."
        className={cx(
          "h-full w-full border-none bg-transparent pl-8 text-sm leading-8 font-normal text-dark transition-opacity duration-200 ease-in-out outline-none placeholder:font-normal placeholder:text-grey",
          isExpanded ? "cursor-text opacity-100" : "cursor-pointer opacity-0",
          hasInputValue ? "pr-8" : "pr-2"
        )}
      />
      <PlainButton
        type="button"
        onMouseDown={(event) => {
          event.preventDefault();
        }}
        onClick={handleQuitSearch}
        className={cx(
          "jugl__focusable-outline absolute top-1/2 right-1 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded transition-opacity duration-200 ease-in-out hover:bg-grey-200",
          hasInputValue ? "opacity-100" : "pointer-events-none opacity-0"
        )}
        tabIndex={hasInputValue ? 0 : -1}
      >
        <CancelIcon className="h-4 w-4" />
      </PlainButton>
    </div>
  );
};
